import { http } from 'utils'
import { make } from 'vuex-pathify'

export default {
  namespaced: true,

  state: {
    asset: null
  },

  actions: {
    ...make.actions('asset'),

    resetAsset ({ dispatch }) {
      dispatch('setAsset', null)
    },

    async getAssetBySerial ({ dispatch }, serial) {
      const response = await http.get('garment-asset-search/serial', { params: { serial } })

      dispatch('setAsset', response.data.data)

      return response.data.data
    }
  },

  mutations: {
    ...make.mutations('asset')
  }
}
